import { useEffect, useState } from "react";
import {
  controlToastState,
  Modal,
  openModal,
  SpinningLoader,
  TextInput,
} from "risa-oasis-ui_v2";
import { fetchDrugLabel } from "../../../api/getCalls/drugLabel";

const DrugLabelModal = ({ onClose }: { onClose: () => void }) => {
  const [drugName, setDrugName] = useState("");
  const [drugData, setDrugData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    openModal("drug-label-modal");
  }, []);

  const handleFetchDrugLabel = async () => {
    if (!drugName.trim()) {
      controlToastState(`drug-name-error`);
      return;
    }

    try {
      setLoading(true);
      const result = await fetchDrugLabel(drugName);

      const parsedResult = JSON.parse(result);
      if (parsedResult.results && parsedResult.results.length > 0) {
        const indications = parsedResult.results[0].indications_and_usage;
        if (indications && indications.length > 0) {
          setDrugData(indications[0]);
          setLoading(false);
        } else {
          setDrugData(
            "No indications and usage information found for this drug.",
          );
          setLoading(false);
        }
      } else {
        setDrugData("No results found for this drug.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching drug label:", error);
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Drug Label"
      onClose={onClose}
      dialogId="drug-label-modal"
      onSave={onClose}
      saveButtonText="Cancel"
      showSingleButton={true}
      cancelText="Cancel"
      heightPercentage={80}
    >
      <div className="flex h-full flex-col gap-4">
        <div
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleFetchDrugLabel();
            }
          }}
        >
          <TextInput
            label="Drug Name"
            required={true}
            id="drug-name"
            onChange={(e) => setDrugName(e.value)}
          />
          <div className="mt-3 flex flex-row gap-2">
            <div className="text-red-500">*</div>
            <div className="text-xs text-primaryGray-13">
              Please enter the drug name and press "Enter" to fetch Indications
              and Usage.
            </div>
          </div>
        </div>
        {loading && (
          <div className="mt-4 flex h-16 w-full items-center justify-center gap-2 p-3">
            <SpinningLoader />
            <div className="font-bold">Fetching Drug Label...</div>
          </div>
        )}
        {drugData && !loading && (
          <div className="mt-4 overflow-y-auto rounded border bg-gray-50 p-4">
            <h3 className="mb-2 font-semibold">Indications and Usage:</h3>
            <div className="whitespace-pre-wrap text-sm text-gray-700">
              {drugData}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DrugLabelModal;
